module.exports = __webpack_public_path__ + "static/media/footorMobile.54c4149a.png";